import { useSelector, shallowEqual } from 'react-redux'
import { selectors } from 'publisher/reducers/pageReducer'

export { selectors }

export default function usePage(selector) {
  return useSelector(state => selector(state.page), shallowEqual)
}